import React from "react";
import {Garage} from "@App/types";
import {Text} from "@eo-locale/react";


export type GarageProfileOpeninghoursProps = {
    garage: Garage
};

export const GarageProfileOpeninghours = React.memo<GarageProfileOpeninghoursProps> (({garage}) => {

    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']

    return (
        <div className={'garageProfile_openinghours col-span-full mb-6 md:mb-8'}>
            <h2 className={'text-lg font-serif mb-3'}><Text id={'profileDetails_opening_hours'}/></h2>
            <ul className={'openingHoursList'}>
                {garage.opening_hours?.map((item, index) => (
                    <li key={index} className={`${item.open === 'geschlossen' ? 'closed' : 'open'}  flex items-center h-6 py-2`}><span><Text id={`profileDetails_days_${days[item.day - 1]}`}/>&nbsp;</span><span className={'w-full text-right'}>{item.open}</span></li>
                ))}
            </ul>
        </div>
    )
})

GarageProfileOpeninghours.displayName = 'GarageProfileOpeninghours'
